export default __webpack_public_path__ + "static/backend-as-a-service-4c2bc7ed90b130657fbcb61d75b0b429.png";